
































































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import KodingIcd from "@/services/KodingIcd";
import EncounterIndex from "@/services/EncounterIndex";
import DialogKodingIcd from "@/components/koding/DialogKodingIcd.vue";
import DialogLihatPemeriksaan from "@/components/koding/DialogLihatPemeriksaan.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate, parseLocalDate } from "@/utils/localDate";
import {
  KodingFilterState,
  KodingListParams,
  KodingKategori,
  KodingRegisterRow,
  KodingSortKey,
  KodingStatusKoding,
  KodingTableOptions
} from "@/types/kodingIcd";

const RENTANG_MAKS_HARI = 31;

const KOLOM_URUT: Record<string, KodingSortKey> = {
  tgl_in: "tgl",
  "unit.nama": "unit"
};

const KATEGORI_UNIT: Record<KodingKategori, string[]> = {
  ranap: ["ranap"],
  ralan: ["ralan", "penunjang"]
};

const KATEGORI_UNIT_SEMUA = ["ralan", "ranap", "penunjang"];

const UNIT_NON_KLINIS = ["80"];

function filterDefault(): KodingFilterState {
  const hariIni = localISODate(new Date());

  return {
    kategori: null,
    koding: null,
    unit: null,
    tglAwal: hariIni,
    tglAkhir: hariIni
  };
}

@Component({
  components: {
    DialogKodingIcd,
    DialogLihatPemeriksaan,
    UnitRuangPicker,
    VCDateTimePicker
  }
})
export default class KodingIcdPage extends Vue {
  items: KodingRegisterRow[] = [];
  totalItems = 0;
  lastPage = 1;

  itemsPerPageOptions = [10, 25, 50, 100];
  loading = false;

  filter: KodingFilterState = filterDefault();

  applied: KodingFilterState = filterDefault();

  cari = "";

  cariAktif = "";

  options: KodingTableOptions = {
    page: 1,
    itemsPerPage: 25,
    sortBy: [],
    sortDesc: []
  };

  dialogKoding = false;
  dialogLihat = false;
  barisLihat: KodingRegisterRow | null = null;
  unitNonKlinis = UNIT_NON_KLINIS;
  registerAktif: string | number | null = null;
  busyReg: string | number | null = null;
  maksTgl = new Date();

  private hasFetched = false;

  kategoriOptions = [
    { text: "Rawat Inap", value: "ranap" },
    { text: "Rawat Jalan / IGD", value: "ralan" }
  ];

  kodingOptions = [
    { text: "Belum Dikoding", value: "belum" },
    { text: "Sudah Dikoding", value: "sudah" },
    { text: "Verified", value: "verified" }
  ];

  statusKodingMeta: Record<KodingStatusKoding, { text: string; color: string }> = {
    belum: { text: "Belum", color: "grey lighten-2" },
    sudah: { text: "Sudah", color: "green lighten-4" },
    verified: { text: "Verified", color: "blue lighten-4" }
  };

  get headers() {
    return [
      { text: "No. RM", value: "pasien.rm", sortable: false },
      { text: "Identitas Pasien", value: "pasien.nama", sortable: false },
      {
        text: "Tgl Masuk",
        value: "tgl_in",
        class: "text-no-wrap",
        cellClass: "text-no-wrap"
      },
      { text: "Resume", value: "resume", width: "12vh", sortable: false },
      { text: "Diagnosis", value: "diagnosis_resume", sortable: false },
      {
        text: "Penginput Koding",
        value: "koder.nama",
        width: "14vh",
        sortable: false
      },
      { text: "Unit", value: "unit.nama", class: "text-no-wrap" },
      {
        text: "Status Koding",
        value: "koding",
        align: "center",
        width: "14vh",
        sortable: false
      },
      { text: "ICD", value: "icd", width: "16vh", sortable: false },
      {
        text: "Aksi",
        value: "action",
        align: "center",
        class: "px-1",
        cellClass: "px-1",
        sortable: false
      }
    ];
  }

  get kategoriUnit(): string[] {
    return this.filter.kategori
      ? KATEGORI_UNIT[this.filter.kategori]
      : KATEGORI_UNIT_SEMUA;
  }

  get cariTrim(): string {
    return (this.cari || "").trim();
  }

  get modeCari(): boolean {
    return this.cariAktif !== "";
  }

  get filterBerubah(): boolean {
    return JSON.stringify(this.filter) !== JSON.stringify(this.applied);
  }

  get bisaReset(): boolean {
    const bawaan = JSON.stringify(filterDefault());

    return (
      JSON.stringify(this.filter) !== bawaan ||
      JSON.stringify(this.applied) !== bawaan
    );
  }

  get tglAwalDate(): Date | null {
    return parseLocalDate(this.filter.tglAwal);
  }

  get tglAkhirDate(): Date | null {
    return parseLocalDate(this.filter.tglAkhir);
  }

  get rentangHari(): number {
    const awal = this.tglAwalDate;
    const akhir = this.tglAkhirDate;

    if (!awal || !akhir) return 0;

    return Math.round((akhir.getTime() - awal.getTime()) / 86400000) + 1;
  }

  get rentangValid(): boolean {
    return this.rentangHari >= 1 && this.rentangHari <= RENTANG_MAKS_HARI;
  }

  get pesanRentang(): string {
    if (this.rentangHari < 1) {
      return "Tgl masuk akhir tidak boleh sebelum tgl masuk awal.";
    }

    return `Rentang maksimal ${RENTANG_MAKS_HARI} hari (saat ini ${this.rentangHari} hari).`;
  }

  setTglAwal(val: Date | null) {
    if (!val) return;

    this.filter.tglAwal = localISODate(val);

    if (this.filter.tglAkhir < this.filter.tglAwal) {
      this.filter.tglAkhir = this.filter.tglAwal;
    }
  }

  setTglAkhir(val: Date | null) {
    if (!val) return;

    this.filter.tglAkhir = localISODate(val);

    if (this.filter.tglAwal > this.filter.tglAkhir) {
      this.filter.tglAwal = this.filter.tglAkhir;
    }
  }

  // ----------------------------------------------------------------- fetch
  @Watch("options", { deep: true })
  onOptionsChange() {
    this.getList();
  }

  tampilkan() {
    if (!this.rentangValid) return;

    this.applied = { ...this.filter };
    this.cari = "";
    this.cariAktif = "";
    this.muatHalamanPertama();
  }

  cariPasien() {
    if (!this.cariTrim) return;

    this.cariAktif = this.cariTrim;
    this.muatHalamanPertama();
  }

  batalCari() {
    this.cari = "";

    if (!this.modeCari) return;

    this.cariAktif = "";
    this.muatHalamanPertama();
  }

  muatHalamanPertama() {
    if (this.options.page !== 1) {
      this.options = { ...this.options, page: 1 };
    } else {
      this.getList();
    }
  }

  resetFilter() {
    this.filter = filterDefault();
    this.tampilkan();
  }

  getList() {
    this.loading = true;
    this.hasFetched = true;

    const f = this.applied;
    const params: KodingListParams = {
      page: this.options.page,
      per_page: this.options.itemsPerPage
    };

    if (this.modeCari) {
      params.q = this.cariAktif;
    } else {
      if (f.kategori) params.kategori = f.kategori;
      if (f.koding) params.koding = f.koding;
      if (f.unit) params.unit = f.unit;
      if (f.tglAwal) params.tgl_start = f.tglAwal;
      if (f.tglAkhir) params.tgl_end = f.tglAkhir;
    }

    const kolomUrut = KOLOM_URUT[(this.options.sortBy || [])[0]];

    if (kolomUrut) {
      params.sort_by = kolomUrut;
      params.sort_desc = !!(this.options.sortDesc || [])[0];
    }

    KodingIcd.getList(params)
      .then(resp => {
        this.items = resp && resp.data ? resp.data : [];
        this.totalItems = resp && resp.meta ? resp.meta.total : 0;
        this.lastPage = resp && resp.meta ? resp.meta.last_page || 1 : 1;
      })
      .catch(() => {
        this.items = [];
        this.totalItems = 0;
        this.lastPage = 1;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  changePerPage(val: number) {
    this.options = { ...this.options, itemsPerPage: val, page: 1 };
  }

  reload() {
    this.getList();
  }

  // ---------------------------------------------------------------- aksi
  bukaKoding(item: KodingRegisterRow) {
    this.registerAktif = item.register_id;
    this.dialogKoding = true;
  }

  lihatPemeriksaan(item: KodingRegisterRow) {
    this.barisLihat = item;
    this.dialogLihat = true;
  }

  identitasRingkas(item: KodingRegisterRow): string {
    return [item.pasien.sex, item.umur].filter(teks => !!teks).join(" · ");
  }

  daftarKode(kode: string[]): string {
    return kode && kode.length ? kode.join(", ") : "-";
  }

  async halamanPemeriksaan(item: KodingRegisterRow) {
    const params = { register: String(item.register_id), rm: item.pasien.rm };

    if (item.kategori !== "ranap") {
      this.$router.push({
        name: "pemeriksaan",
        params: { ...params, page: "tab-soap" }
      });

      return;
    }

    this.busyReg = item.register_id;

    await EncounterIndex.regRanap(item.register_id, item.pasien.rm).catch(
      () => undefined
    );

    this.busyReg = null;

    this.$router.push({
      name: "pemeriksaan-ranap",
      params,
      query: { topTab: "tab-rekam-medis" }
    });
  }

  setelahSimpan() {
    this.getList();
  }

  mounted() {
    this.$nextTick(() => {
      if (!this.hasFetched) this.getList();
    });
  }
}
